import { Component } from '@angular/core';

@Component({
  selector: 'stay-connected',
  templateUrl: './stay-connected.component.html',
  styleUrls: ['./stay-connected.component.scss']
})
export class StayConnectedComponent {

}
